/*
 * This is a development logger that can be used to log messages to the console.
 * It is used to log messages to the console that are only visible
 * when the VITE_DEV_LOGGER_PATTERN environment variable is set and matches the message prefix.
 *
 * VITE_DEV_LOGGER_PATTERN='(🔥|🔆|✳️).*'
 *
 * @example
 * import { devLogger } from 'src/utils/devLogger';
 *
 * devLogger.log('🔆Loader in group detail');
 */

const PATTERN = import.meta.env.VITE_DEV_LOGGER_PATTERN || "";

const reg = new RegExp(PATTERN, "i");

export const devLogger = {
  log(message: string, ...args: any[]) {
    if (PATTERN.length && reg.test(message)) {
      console.log(new Date().toISOString(), message, ...args);
    }
  }
};
